var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "nav-bar" }, [
      _c(
        "a",
        {
          staticClass: "nav-bar-close-button",
          on: { click: _vm.onCloseClicked }
        },
        [_c("span", { staticClass: "b-sprite-quiz-v3-x-black-large" })]
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "errorScreen" },
      [
        _c("h2", [_vm._v("404")]),
        _vm._v(" "),
        _c("p", [_vm._v("Hmm… we can't find that lesson.")]),
        _vm._v(" "),
        _c("NotFoundError"),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "buttonWrapper" },
          [
            _c(
              "Button",
              { attrs: { secondary: "" }, on: { click: _vm.onCloseClicked } },
              [_vm._v(" Return to course page ")]
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }